<template>
    <v-row justify="center">
        <v-dialog v-model="mergeStationModal" persistent max-width="600px">
            <v-card>
                <v-card-title>
                    <span class="text-h5">Merge with station</span>
                    <span class="text-subtitle-2 ">You can merge with station which have no active station locations and is newly installed to the field.</span>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="12">
                                <v-select
                                    item-value="id"
                                    item-text="name"
                                    searchable
                                    return-object
                                    :loading="loading"
                                    :items="probes"
                                    label="Station"
                                    v-model="selectedStation"
                                >
                                </v-select>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="handleCloseClick">
                        Close
                    </v-btn>
                    <v-btn color="blue darken-1" text @click="handleMergeClick">
                        Merge
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'

export default {
    name: 'StationRegionModal',
    computed: {
        ...mapState('probe', ['activeProbe', 'mergeStationModal', 'probes']),
        ...mapState('country', ['countries']),
    },
    beforeDestroy() {
        this.setMergeStationModal(false)
    },
    async mounted() {
        this.loading = true;

        if (!this.probes.length) {
            await this.fetchAppSettings()
        }

        this.loading = false;
    },
    data() {
        return {
            selectedStation: {},
            loading: true,
        }
    },

    methods: {
        ...mapMutations('probe', ['setMergeStationModal']),
        ...mapActions('probe', ['mergeStations', 'fetchProbe']),
        ...mapActions('app', ['fetchAppSettings']),

        async handleCloseClick() {
            await this.setMergeStationModal(false)
        },
        async handleMergeClick() {
            const payload = {
                station_id: this.activeProbe.id,
                merge_station_id: this.selectedStation.id,
            }

            await this.mergeStations(payload)
            await this.setMergeStationModal(false)
            await this.fetchProbe(this.activeProbe.id)
        }
    },
}
</script>

<style scoped></style>
